import { render, staticRenderFns } from "./ShopItemInquire.vue?vue&type=template&id=4debb538&scoped=true&"
import script from "./ShopItemInquire.vue?vue&type=script&lang=js&"
export * from "./ShopItemInquire.vue?vue&type=script&lang=js&"
import style0 from "./ShopItemInquire.vue?vue&type=style&index=0&id=4debb538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4debb538",
  null
  
)

export default component.exports